<!-- @ts-nocheck -->
<template>
  <q-select v-feature-flag="'IstFormSelect'"
            v-model="selectedOptions"
            :stack-label="!dense"
            use-input
            :hide-selected="multiple !== ''"
            fill-input
            filled
            :multiple="multiple == ''"
            :use-chips="multiple == ''"
            :dense="true"
            input-debounce="0"
            option-value="value"
            option-label="label"
            ref="IstFormSelect"
            :options="curOptions"
            :disabled="disabled"
            :disable="disabled"
            :readonly="disabled"
            :label="getLabel()"
            autocomplete="off"
            autocorrect="off"
            autocapitalize="off"
            spellcheck="false"
            style="padding-bottom: 0"
            popup-content-style="z-index: 100000"
            :input-style="inputStyle"
  >
    <template v-slot:option="scope, index">
      <dtpItemLabel header v-show="showGroupText(scope.opt.grouptext, index)">{{
        scope.opt.grouptext
      }}</dtpItemLabel>
      <dtpItem v-bind="scope.itemProps">
        <dtpItemSection avatar v-if="scope.opt.icon">
          <dtpIcon :name="scope.opt.icon" />
        </dtpItemSection>
        <dtpItemSection>
          <dtpItemLabel><span v-html="scope.opt.label" /></dtpItemLabel>
          <dtpItemLabel v-if="scope.opt.sublabel" caption>{{ scope.opt.sublabel }}</dtpItemLabel>
        </dtpItemSection>
      </dtpItem>
    </template>

    <slot v-for="(_, name) in $slots" :name="name" />
    <template v-for="(_, name) in $slots" v-slot:[name]="slotData">
      <slot :name="name" v-bind="slotData" />
    </template>
  </q-select>
  <CuiSelect
    v-feature-flag="'!IstFormSelect'"
    v-bind="$attrs"
    :modelValue="localvalue"
    :options="curOptions"
    optionLabel="label"
    optionValue="value"
    :label="getLabel()"
    :disabled="disabled"
    :invalid="false"
    :error="undefined"
    filterable
    clearable
    :placeholder="label || 'Vælg en option...'"
    @update:modelValue="
      localvalue = $event;
      updateValue();
    "
  />
</template>
<script setup lang="ts">
// @ts-nocheck
import { ref, watch, computed } from "vue";
import { QSelect } from "quasar";

export type optiontype = {
  label: string;
  sublabel?: string;
  value: any;
  icon?: string;
  grouptext?: string;
};

defineOptions({ name: "IstFormSelect" });

const props = withDefaults(
  defineProps<{
    modelValue?: any;
    disabled?: boolean;
    label?: string;
    options?: Array<optiontype>;
    dense?: boolean;
    multiple?: string;
    inputStyle?: string;
    clearable?: boolean;
    clearValue?: any;
  }>(),
  {
    modelValue: null,
    disabled: false,
    label: undefined,
    options: () => [],
    dense: false,
    multiple: "false",
    inputStyle: undefined,
    clearable: false,
    clearValue: undefined
  }
);

const emit = defineEmits<{
  (e: "input", val: any): void;
  (e: "change", val: any): void;
  (e: "update:modelValue", val: any): void;
}>();

const qselect = ref<QSelect | null>(null);
const ldense = ref(false);
const curOptions = ref<Array<optiontype>>([]);
const localvalue = ref<any>(null);

const updateValue = () => {
  emit("input", localvalue.value);
  emit("change", localvalue.value);
  emit("update:modelValue", localvalue.value);
  return localvalue.value;
};

watch(
  () => [props.modelValue],
  ([val]) => {
    if (val) {
      try {
        localvalue.value = val;
      } catch {
        localvalue.value = undefined;
      }
    } else {
      localvalue.value = undefined;
    }
    emit("change", localvalue.value);
    emit("update:modelValue", localvalue.value);
  },
  { immediate: true }
);

watch(
  () => props.dense,
  (val) => {
    ldense.value = val as boolean;
  },
  { immediate: true }
);

watch(
  () => props.options,
  (val: any) => {
    curOptions.value = val || [];
    let oldtxt = "";
    for (let index = 0; index < curOptions.value.length; index++) {
      const element = curOptions.value[index];
      const s = element.grouptext ? element.grouptext : "";
      if (s !== "" && oldtxt != s) {
        oldtxt = s;
      } else {
        element.grouptext = undefined;
      }
    }
  },
  { immediate: true }
);

const showGroupText = (groupText: string, index: number) => {
  if (index === 0) {
    return groupText === "" ? false : true;
  }
  const previusOption = curOptions.value[index - 1];
  return previusOption.grouptext !== groupText && groupText !== "" ? true : false;
};

const selectedOptions = computed({
  get() {
    if (props.multiple === "") {
      if (localvalue.value) {
        return (props.options || []).filter((value: optiontype) => {
          return localvalue.value.some((localVal: any) => objectComparer(localVal, value.value));
        });
      }
      return [];
    } else {
      return (props.options || []).find((value: optiontype) => localvalue.value == value.value);
    }
  },
  set(selection: any) {
    if (props.multiple === "") {
      if (Array.isArray(selection)) {
        localvalue.value = selection.map((value: optiontype) => value.value);
      } else {
        localvalue.value = props.clearValue !== undefined ? props.clearValue : null;
      }
      (qselect.value as any)?.updateInputValue?.("", false);
    } else {
      // Handle clearing: if selection is null/undefined or doesn't have a value property
      if (selection === null || selection === undefined) {
        localvalue.value = props.clearValue !== undefined ? props.clearValue : undefined;
      } else if (typeof selection === "object" && "value" in selection) {
        localvalue.value = selection.value;
      } else {
        // Selection might be the clearValue itself
        localvalue.value = selection;
      }
    }
    updateValue();
  }
});

const objectComparer = (obj1: any, obj2: any) => {
  if (obj1?.equals && obj2?.equals) {
    return obj1.equals(obj2) && obj2.equals(obj1);
  }
  const obj1Keys = Object.keys(obj1 || {});
  const obj2Keys = Object.keys(obj2 || {});
  if (obj1Keys.length !== obj2Keys.length) {
    return false;
  }
  for (const key of obj1Keys) {
    const obj1Val = obj1[key];
    const obj2Val = obj2[key];
    if (obj1Val === undefined) {
      if (obj2Val !== undefined) {
        return false;
      }
    }
    if (obj1Val !== obj2Val) {
      return false;
    }
  }
  return true;
};

const getLabel = () => {
  if (!props.label) return;
  const s = props.label.charAt(0).toUpperCase() + props.label.substring(1).toLowerCase();
  return s ? s : undefined;
};
</script>
<style scoped>
.showerror {
  padding-bottom: 20px !important;
}
</style>
